import gql from "graphql-tag";
import WORKFLOWABLE_FRAGMENT from "@/graphql/fragments/workflowable";
import WORKFLOW_STATUS_FRAGMENT from "@/graphql/fragments/workflow_status";
import ATTENDANCE_PLACE_FRAGMENT from "@/graphql/fragments/attendance_place";

export default gql`
  fragment attendanceParts on Attendance {
    id
    createdAt
    scheduledFor
    arrivedAt
    healthInsuranceProductName
    fittedSchedule
    warelineId
    ${WORKFLOWABLE_FRAGMENT}
    employeeAttendancePlaces {
      id
      name
      parent {
        id
        name
      }
    }
    patientRisks {
      id
      name
      color {
        id
        color
        saturation
      }
    }
    notes {
      id
      message
      updatedAt
      attendanceId
      category {
        id
        name
        priority
        color {
          id
          color
          saturation
        }
      }
    }
    patient {
      id
      name
      birthDate
      warelineId
      pictureUrl 
      avatar {
        id
      }
    }
    employee {
      id
      name
    }
    serviceType {
      id
      name
    }
    therapies {
      id
      interval
      numberOfApplications
      dilation
      refract
      applicationRoute {
        id
        name
      }
      applicationSite {
        id
        name
      }
      medicine {
        id
        name
      }
      applications {
        id
        batch
        createdAt
      }
    }
    lastEsign {
      id
      status
      signedAt

    }
  }

  ${WORKFLOW_STATUS_FRAGMENT}
  ${ATTENDANCE_PLACE_FRAGMENT}
`;
